/**
 * Clipboard writes reject on an http:// origin or a denied permission, and a
 * copy button that fails quietly is worse than no button at all — the operator
 * pastes whatever was in the clipboard before and blames the value. Every
 * caller therefore has to handle this rejection visibly.
 */
export async function copyText(value: string): Promise<void> {
  if (typeof navigator.clipboard?.writeText !== "function") {
    throw new Error("Clipboard tidak tersedia di origin ini (butuh https atau localhost).");
  }
  await navigator.clipboard.writeText(value);
}
